import $ from 'jquery'

const MOBILE_WINDOW_WIDTH = 698

$(window).on('load resize', (): void => {
	const windowWidth = $(window).width()

	if (windowWidth && windowWidth <= MOBILE_WINDOW_WIDTH) {
		$('body').addClass('mobile-view')
	} else {
		$('body').removeClass('mobile-view')
	}
})
